export const RightSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="8"
      height="15"
      viewBox="0 0 8 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.53754 0.875905C0.925905 0.483233 1.55906 0.479742 1.95173 0.868107L7.16226 6.02148C7.95373 6.80428 7.95373 8.08267 7.16226 8.86546L1.95173 14.0188C1.55906 14.4072 0.925905 14.4037 0.53754 14.011C0.149175 13.6184 0.152666 12.9852 0.545338 12.5969L5.75586 7.44347L0.545338 2.2901C0.152666 1.90173 0.149175 1.26858 0.53754 0.875905Z"
        fill={props.fill || 'black'}
      />
    </svg>
  )
}
